
(function userControllerDefinition() {
    'use strict';
    angular.module('User')
        .controller('UserAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminUserService', 'authExtend', 'messages','adminOrganizationalUnitService',
            function userController($scope, config, $state, $translate, errors, adminUserService, authExtend, messages, adminOrganizationalUnitService) {

                $scope.load = function () {
                    $scope.title = 'UserAdd'; 
                    $scope.requiredOu = authExtend.getOrganizationId() ? true : false;
                    $scope.enableControls = true;
                    $scope.userOu = {
                        nickName: '',
                        userName: '',
                        fullName: '',
                        mail: '',
                        mailConfirm: '',
                        enabled: true,
                        creationDate: '',
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName(),
                        securityLevelConfig: []
                    };

                    if ($scope.userOu.organizationalUnitId !== undefined || $scope.userOu.organizationalUnitId !== null) {
                        adminOrganizationalUnitService.getById($scope.userOu.organizationalUnitId).then(function getOk(result) {
                            $scope.userOu.securityLevelConfig = result.securityLevelConfig;
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    };
                };

                $scope.validMails = function () {
                    if ($scope.userOu.mail) {
                        if ($scope.userOu.mail !== $scope.userOu.mailConfirm) {
                            $scope.userForm.email2.$invalid = true;
                            $scope.userForm.email2.$valid = false;
                            return false;
                        } else {
                            $scope.userForm.email2.$invalid = false;
                            $scope.userForm.email2.$valid = true;
                            return true;
                        }
                    }
                    return false;
                }

                $scope.findUser = function () {
                    if (!$scope.userOu.mail ||
                        $scope.userOu.nickName ||
                        $scope.userOu.firstName ||
                        $scope.userOu.lastName) {
                        return false;
                    }

                    adminUserService.getByMail($scope.userOu.mail).then(function getOk(result) {
                        if (result && result.length > 0) {
                            messages.showConfirm('UserExistInDifferentOu', 'warning').then(function (confirm) {
                                if (confirm) {
                                    $scope.enableControls = false;
                                    $scope.fillUser(result[0]);
                                } else {
                                    $scope.enableControls = true;
                                    $scope.userOu.id = undefined;
                                    $scope.userOu.mail = '';
                                    $scope.userOu.mailConfirm = '';
                                    $scope.userOu.nickName = '';
                                    $scope.userOu.firstName = '';
                                    $scope.userOu.lastName = '';
                                }
                            });
                        } else {
                            $scope.enableControls = true;
                            $scope.userOu.id = undefined;
                            $scope.userOu.mailConfirm = '';
                            $scope.userOu.nickName = '';
                            $scope.userOu.firstName = '';
                            $scope.userOu.lastName = '';
                        }
                    }, function getError(error) {
                        $scope.enableControls = true;
                        errors.showError(error);
                    });
                };

                $scope.save = function () {
                    if (!$scope.validMails()) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('UserInvalidMailConfirm');
                        return false;
                    }

                    if (!$scope.userForm.$valid) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    var userOu = angular.copy($scope.userOu);
                    
                    return adminUserService.create(userOu).then(function () {
                        $state.go('user-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("user-find");
                };

                $scope.fillUser = function (login) {
                    $scope.userOu.nickName = login.nickName;
                    $scope.userOu.firstName = login.firstName;
                    $scope.userOu.lastName = login.lastName;
                    $scope.userOu.mailConfirm = $scope.userOu.mail;
                    $scope.userOu.loginId = login.id;
                };
            
                $scope.load();
            }
        ]);
})();